export default "__VITE_ASSET__DoBsvIq7__"